import React, { useEffect } from 'react';
import './tailwind.css';
import './main.scss';
import { ConfigProvider } from 'antd';
import BasicLayout from './layouts/BasicLayout.jsx';
import { RootProvider } from './hooks/useRoot.jsx';

const  MainRootPage = () => {

  useEffect(() => {
    const dpr = window.devicePixelRatio;
    if(dpr == 1.5 || dpr == 1.25) {
      document.body.style.zoom = (-0.6) * dpr + 1.55;
      document.body.style.backgroundColor = '#ffffff';
    } else {
      document.body.style.zoom = 1;
      document.body.style.backgroundColor = '#ffffff';
    }
    return () => {
      document.body.style.zoom = 1;
      document.body.style.backgroundColor = '#000000';
    };
  }, []);

  return (
    <RootProvider>
      <ConfigProvider theme={{
        token: {
          colorBorder: '#00A32E',
          colorPrimary: '#00A32E',
            
          colorBgContainerDisabled: '#00A32E80 !important',
          colorTextDisabled: '#ffffff',
          selectorBg: ''
        }
      }}>
        <BasicLayout></BasicLayout>
      </ConfigProvider>
    </RootProvider>

  );
};

export default MainRootPage;